import { useForm } from "react-hook-form";
import { usePhotoUpload } from "../../hooks/usePhotoUploadhook";
import { Button, InputField } from "../forms";
import { LogoUploader } from "../generic/LogoUploader";
import { PhotoUpload } from "../generic/PhotoUpload";
import { addressRegex, emailReg, numReg, textReg } from "../../utils/regex";
import { FaArrowRight } from "react-icons/fa6";
import { ListPicker } from "../generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { companySizes, countries } from "../../constant/data";
import { FiSave } from "react-icons/fi";
import { toast } from "react-toastify";
import { onCreateOragnization } from "../../services/auth/organization";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";

export default (props: any) => {
  var choosephotohook = usePhotoUpload();
  var { control, handleSubmit, watch } = useForm();
  const watchedFields = watch(["email", "orgname", "phone", "address"]);
  const countrypicked = usePickerhook();
  const comapnysizepicked = usePickerhook();

  const { config, SelectedOrg } = useStateGetter();
  const { setLoading, setSelectedorg } = useStateSetter();

  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      countrypicked.pickedRole &&
      comapnysizepicked.pickedRole
  );

  const onSubmit = async (data: any) => {
 
    let postdata = new FormData();
    postdata.append("orgName", data.orgname);
    postdata.append("orgEmail", data.email);
    postdata.append("address", data.address);
    postdata.append("orgPhoneNumber", data.phone);
    postdata.append("logo", choosephotohook.file);
    postdata.append("country", countrypicked.pickedRole.name);
    postdata.append("size", comapnysizepicked.pickedRole?.code);

    setLoading(true);
    try {
      var respose = await onCreateOragnization(postdata, config);

      setSelectedorg(respose.data);
      console.log(respose.data);
      setLoading(false);
      props.action(1);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
      setLoading(false);
    }

    props.setpostdata((prev: any) => ({ ...prev, ...postdata }));
  };
  return (
    <div className={`w-[50%] p-6 bg-white ${props.style}`}>
      {props.issetting ? (
        <>
          {" "}
          <div className=" rounded-full flex justify-between items-center  ">
            <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
              Company Profile
            </p>

            <Button
              width={200}
              disabled={!areFieldsFilled}
              text={
                <>
                  {" "}
                  <FiSave size={15} className=" mx-1 inline" /> Save Changes
                </>
              }
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
          <hr className="w-full" />
        </>
      ) : (
        <p className="font-bold text-sm ">Company/Business Information</p>
      )}
      <div className=" p-8 flex">
        <div className="self-start">
          <LogoUploader hook={choosephotohook} />
        </div>

        <div className={` pl-6 ${props.issetting ? "w-[60%] " : "w-full"}`}>
          <InputField
            name="orgname"
            title="Company/Business Name"
            placeholder={"Company/Business Name"}
            // defaultvalue={SelectedOrg.orgName}
            control={control}
            rules={{
              required: "Company/Business Name is required",
              pattern: {
                value: textReg,
                message: "Invalid Company/Business Name",
              },
            }}
          />

          <InputField
            name="email"
            title="Email Address"
            placeholder={"Enter Email Address"}
            // defaultvalue={SelectedOrg.orgEmail}
            control={control}
            rules={{
              required: "Email Address is required",
              pattern: {
                value: emailReg,
                message: "Invalid Email Address",
              },
            }}
          />
          <InputField
            name="phone"
            title="Phone number"
            placeholder={"Enter phone number"}
            control={control}
            // defaultvalue={SelectedOrg.orgPhoneNumber}
            rules={{
              required: "Phone number is required",
              pattern: {
                value: numReg,
                message: "Invalid phone number",
              },
            }}
            type={"number"}
          />
          <InputField
            name="address"
            title="Company/Business address"
            placeholder={"Company/Business address"}
            control={control}
            // defaultvalue={SelectedOrg.address}
            rules={{
              required: "Company/Business address is required",
              pattern: {
                value: addressRegex,
                message: "Invalid Company/Business address",
              },
            }}
          />
          <ListPicker
            hook={countrypicked}
            title="Country"
            list={countries}
            defaultvalue={
              countries.filter((i) => i.name == SelectedOrg.country)[0]
            }
          />

          <ListPicker
            hook={comapnysizepicked}
            title="Company Size"
            defaultvalue={
              companySizes.filter((i) => i.code == SelectedOrg.size)[0]
            }
            list={companySizes}
          />
          {!props.issetting && (
            <div className=" flex justify-end">
              <Button
                width={150}
                disabled={!areFieldsFilled}
                text={
                  <>
                    Select Module
                    <FaArrowRight size={15} className=" ml-1 inline" />
                  </>
                }
                onBtnClick={handleSubmit(onSubmit)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
